import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于黑料网站的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 md:py-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-200 group-open:rotate-180">
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-4 md:pb-5">
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}